module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/125.e1866c7c.svg";